import {useState} from "react";
import {useCookies} from "react-cookie";

function useMerchantProfile(tenantId, storeId, merchantProfileId, setMerchantProfile) {

    const [store, setStore] = useState({});
    const [tenant, setTenant] = useState({});
    const [currencies, setCurrencies] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [originalCurrencies, setOriginalCurrencies] = useState([]);
    const [PSPs, setPSPs] = useState({});
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }

    async function getPSPs() {
        const response = await fetch(apiRoot + '/backoffice/payment-service-providers?size=100', {headers: apiHeaders});
        const data = await response.json();
        setPSPs(data.content);
    }

    async function getMerchantProfile(pspId) {
        const response = await fetch(apiRoot + '/backoffice/payment-service-providers/' + pspId + '/merchant-profiles/' + merchantProfileId, {headers: apiHeaders});
        const data = await response.json();
        setMerchantProfile(data);
        setOriginalCurrencies(data.currencies);
    }

    async function getStoreDetails() {
        const response = await fetch(apiRoot + '/backoffice/tenants/' + tenantId + '/stores/' + storeId, {headers: apiHeaders});
        const data = await response.json();
        setStore(data);
    }

    async function getTenantDetails() {
        const response = await fetch(apiRoot + '/backoffice/tenants/' + tenantId, {headers: apiHeaders});
        const data = await response.json();
        setTenant(data);
    }

    async function getCurrencies() {
        const response = await fetch(apiRoot + '/backoffice/payment-service-providers/currencies', {headers: apiHeaders});
        const data = await response.json();
        setCurrencies(data);
    }

    async function getPaymentMethodsForPsp(pspId) {
        const response = await fetch(apiRoot + '/backoffice/payment-service-providers/' + pspId + '/payment-methods', {headers: apiHeaders});
        const data = await response.json();
        setPaymentMethods(data.content);
    }


    return {
        store, setStore,
        tenant, setTenant,
        currencies, setCurrencies,
        originalCurrencies, setOriginalCurrencies,
        PSPs, setPSPs,
        getPSPs,
        getMerchantProfile,
        getStoreDetails,
        getTenantDetails,
        getCurrencies,
        getPaymentMethodsForPsp,
        paymentMethods
    };
}
export default useMerchantProfile;
